import PropTypes from 'prop-types'
import useError from '../../hooks/useError'
import styles from './GenericSelect.module.css'

export default function GenericSelect({
  options = [],
  value = '',
  onChange = () => {},
  label,
  placeholder = 'Seleccionar...',
  id,
  className = '',
  errores = {},
  disabled = false,
  name = ''
}) {
  const { ShowError, hayError } = useError(errores, name)

  const obtenerClases = () => {
    const clases = [styles.select]
    if (className) {
      clases.push(className)
    }
    if (disabled) {
      clases.push('disabled')
    }
    if (hayError) {
      clases.push('error')
    }
    return clases.join(' ')
  }

  return (
    <div className={`${styles.container} ${className}`}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <select
        id={id}
        className={obtenerClases()}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        name={name}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {<ShowError />}
    </div>
  )
}

GenericSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  errores: PropTypes.object,
  disabled: PropTypes.bool,
  name: PropTypes.string
}
